// Copyright (c) Microsoft Corporation. All rights reserved.
export var Trilean;
(function (Trilean) {
    Trilean.YES = true;
    Trilean.NO = false;
    Trilean.UNKNOWN = undefined;
})(Trilean || (Trilean = {}));
//# sourceMappingURL=Trilean.js.map